import { CacheableState } from '@utils/cacheable-state';

export interface ProfileState {
  updateProfileData: CacheableState<Array<any>>;
  updatePassword: CacheableState<boolean>;
  updatePhoto: CacheableState<Array<any>>;
}

export function profileInitialState(): ProfileState {
  return {
    updateProfileData: initialDataSubState().updateProfileData,
    updatePassword: initialDataSubState().updatePassword,
    updatePhoto: initialDataSubState().updatePhoto,
  };
}
export function initialDataSubState(): ProfileState {
  return {
    updateProfileData: new CacheableState(),
    updatePassword: new CacheableState(),
    updatePhoto: new CacheableState(),
  };
}
